import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2 10c0-.552.347-1 .774-1h14.452c.427 0 .774.448.774 1s-.347 1-.774 1H2.774C2.347 11 2 10.552 2 10",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }